module.exports = __webpack_public_path__ + "static/media/search_icon.0a482e62.svg";